enum TestStartDisplayType {
  LOADING,
  START,
  ERROR,
}

export default TestStartDisplayType;
